import { Component, OnDestroy, OnInit } from '@angular/core';
import { OverlayService, ToastDefinition, ModalDefinition, DialogDefinition, NoticeDefinition } from '../../../services/overlay.service';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';

@Component({
	selector: 'bb-overlay',
	templateUrl: './bb-overlay.component.html',
	styleUrls: ['./bb-overlay.component.scss']
})

export class BbOverlayComponent implements OnInit, OnDestroy {

	public toasts: ToastDefinition[] = [];
	public modals: ModalDefinition[] = [];
	public dialogs: DialogDefinition[] = [];
	public notices: NoticeDefinition[] = [];
	public loading = false;

	private acceptClicks = false;
	private loadingTimeout: any;
	private subscriptions = new Subscription();

	constructor(private overlayService: OverlayService, private router: Router) { }

	ngOnInit() {
		this.subscriptions.add(this.overlayService.createToastObservable.subscribe((toast: ToastDefinition) => {
			this.addToast(toast);
		}));

		this.subscriptions.add(this.overlayService.createModalObservable.subscribe((modal: ModalDefinition) => {
			this.addModal(modal);
		}));

		this.subscriptions.add(this.overlayService.removeModalObservable.subscribe((modal: ModalDefinition) => {
			this.removeModal(modal);
		}));

		this.subscriptions.add(this.overlayService.createDialogObservable.subscribe((dialog: DialogDefinition) => {
			this.addDialog(dialog);
		}));

		this.subscriptions.add(this.overlayService.createNoticeObservable.subscribe((notice: NoticeDefinition) => {
			this.addNotice(notice);
		}));

		this.subscriptions.add(this.overlayService.loadingObservable.subscribe((loading: boolean) => {
			if (loading) {
				clearTimeout(this.loadingTimeout);
				// ExpressionChangedAfterItHasBeenCheckedError
				setTimeout(() => {
					this.loading = true;
				});
			} else {
				// prevent flickering / really short loaders
				this.loadingTimeout = setTimeout(() => {
					this.loading = false;
				}, 500);
			}
		}));

		this.router.events.subscribe((event: any) => {
			if (event instanceof NavigationEnd) {

				// clear all
				this.loading = false;

				this.modals.forEach(modal => {
					this.removeModal(modal);
				});

				this.dialogs.forEach(dialog => {
					this.removeDialog(dialog);
				});

				this.notices.forEach(notice => {
					this.removeNotice(notice);
				});
			}
		});

	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	addToast(toast: ToastDefinition) {
		this.toasts.push(toast);
	}

	removeToast(toast: ToastDefinition) {
		const index: number = this.toasts.indexOf(toast);

		if (index > -1) {
			this.toasts.splice(index, 1);
		}
	}

	addModal(modal: ModalDefinition) {
		this.modals.push(modal);

		setTimeout(() => {
			this.acceptClicks = true;
		}, 1000);
	}

	removeModal(modal: ModalDefinition) {

		const index: number = this.modals.indexOf(modal);

		if (index > -1) {
			this.modals.splice(index, 1);
		}
	}

	addDialog(dialog: DialogDefinition) {

		const originalOnCancel = dialog.onCancel;

		dialog.onCancel = () => {
			this.removeDialog(dialog);

			if (originalOnCancel) {
				originalOnCancel();
			}
		};

		const originalOnConfirm = dialog.onConfirm;

		dialog.onConfirm = () => {

			const confirmSubject = originalOnConfirm();

			if (confirmSubject) {
				confirmSubject.subscribe((result: boolean) => {
					this.removeDialog(dialog);
				});
			} else {
				this.removeDialog(dialog);
			}

			return confirmSubject;
		};

		const originalOnSaveAndClose = dialog.onSaveAndClose;

		dialog.onSaveAndClose = () => {
			const saveConfirmSubject = originalOnSaveAndClose();

			if (saveConfirmSubject) {
				saveConfirmSubject.subscribe((result: boolean) => {
					this.removeDialog(dialog);
				});
			} else {
				this.removeDialog(dialog);
			}

			return saveConfirmSubject;
		};

		this.dialogs.push(dialog);
	}

	addNotice(notice: NoticeDefinition) {

		const originalOnConfirm = notice.onConfirm;

		notice.onConfirm = () => {

			if (originalOnConfirm) {
				const confirmSubject = originalOnConfirm();

				if (confirmSubject) {
					confirmSubject.subscribe((result: boolean) => {
						this.removeNotice(notice);
					});
				} else {
					this.removeNotice(notice);
				}

				return confirmSubject;
			} else {
				this.removeNotice(notice);
			}
		};

		const originalOnCopy = notice.onCopy;

		notice.onCopy = () => {
			if (originalOnCopy) {
				originalOnCopy();
			}
		};

		this.notices.push(notice);
	}

	removeDialog(dialog: DialogDefinition) {
		const index: number = this.dialogs.indexOf(dialog);

		if (index > -1) {
			this.dialogs.splice(index, 1);
		}
	}

	removeNotice(notice: NoticeDefinition) {
		const index: number = this.notices.indexOf(notice);

		if (index > -1) {
			this.notices.splice(index, 1);
		}
	}

	setTitle(title: string, dialog: DialogDefinition) {
		if (dialog) {
			dialog.title = title;
		}
	}

	onModalClose() {
		this.modals = [];
	}

	overlayClicked() {
		if (this.acceptClicks) {
			let allowClose = true;
			this.modals.forEach((modal) => {
				if (modal.allowClose) {
					allowClose = allowClose && modal.allowClose();
				}
			});
			if (allowClose) {
				this.modals = [];
				this.acceptClicks = false; // hmmm vrijdagmiddag
			}
		}
	}
}
